import { ChainId } from '@yetiswap/sdk'
import { YTS, ZERO_ADDRESS, BOBA } from '../../../constants'
import EthLogo from '../../../assets/images/ethereum-logo.png'
import BOBALogo from '../../../assets/images/Boba Token.png'
import YTSLogo from '../../../assets/logo/token-logo.png'

export interface ISaleTokenList {
  name: string
  image: string
  [key: number]: string
}

export const SaleTokenList: ISaleTokenList[] = [
  {
    name: 'YTS',
    image: YTSLogo,
    [ChainId.BOBA]: YTS[ChainId.BOBA].address,
    [ChainId.BOBATEST]: YTS[ChainId.BOBATEST].address
  }, {
    name: 'BOBA',
    image: BOBALogo,
    [ChainId.BOBA]: BOBA[ChainId.BOBA].address,
    [ChainId.BOBATEST]: BOBA[ChainId.BOBATEST].address
  },
  {
    name: 'ETH',
    image: EthLogo,
    [ChainId.BOBA]: ZERO_ADDRESS,
    [ChainId.BOBATEST]: ZERO_ADDRESS,
  }
]
